import { useEffect, useState } from "react";
import { Plus, Search } from "lucide-react";
import { adminApi, inr, PLACEHOLDER } from "@/lib/api";
import { inputCls } from "@/admin/ui";

export function ProductPicker({ onPick, exclude = [], testid = "product-picker" }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!q.trim()) {
      setItems([]);
      return undefined;
    }
    const t = setTimeout(() => adminApi.get("/products", { params: { q, limit: 8 } }).then((r) => setItems(r.data.items)), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div data-testid={testid}>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-3 text-zinc-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search products to add…" className={`${inputCls} pl-9`} data-testid={`${testid}-search`} />
      </div>
      {items.length > 0 && (
        <ul className="border border-t-0 border-zinc-200 divide-y divide-zinc-100 max-h-72 overflow-y-auto">
          {items.map((p) => {
            const added = exclude.includes(p.id);
            return (
              <li key={p.id} className="flex items-center gap-3 px-3 py-2 text-sm bg-white">
                <img src={p.image || PLACEHOLDER} alt="" className="w-9 h-9 object-cover border border-zinc-200" />
                <div className="flex-1 min-w-0"><b className="text-xs uppercase font-arial">{p.artist}</b><div className="truncate text-zinc-600">{p.title} <span className="text-zinc-400 font-arial text-xs">{p.sku} · {inr(p.price)}</span></div></div>
                <button disabled={added} onClick={() => onPick(p)} className="px-2.5 py-1.5 text-xs border border-zinc-300 hover:border-black disabled:opacity-40 flex items-center gap-1" data-testid={`${testid}-add-${p.sku}`}>
                  <Plus className="w-3.5 h-3.5" /> {added ? "Added" : "Add"}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
